import {API_URL, SOCKET} from "../../../../URL";
import {
    ADD_CARD_TO_LIST, CREATE_BOARD_LIST, DELETE_ATTACHMENT,
    DELETE_BOARD_LIST, MAKE_COVER, RENAME_LIST,
    SET_ACTIVE_BOARD, SET_ATTACHMENT,
    SET_BOARD,
    SET_BOARD_LISTS, SET_CARD_MEMBER, SET_SEARCH_BOARDS
} from "../../../constants";

export const BoardsAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/get/boards/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id}),
        });

        const data = await response.json();

        dispatch({type: SET_BOARD, payload: data});
    };
};

export const BoardAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/get/board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id}),
        });

        const data = await response.json();
        dispatch({type: SET_ACTIVE_BOARD, payload: data});
    }
}
export const RenameBoard = (id, name) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/update/rename_board_name/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id, name})
        });
        const data = await response.json();
        dispatch({type: SET_ACTIVE_BOARD, payload: data});

        SOCKET.emit("rename_board", {
            board_id: id,
            board: data
        });
    }
}
export const BoardListsAPI = (id, updated_at) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/get/board_lists/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id, updated_at})
        })
        const data = await response.json();
        dispatch({type: SET_BOARD_LISTS, payload: data})

        SOCKET.emit("board_lists", {
            board_id: id,
            lists: data
        });
    }
}
export const CreateBoardListAPI = (board_id, title, sort) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/board_list/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({board_id, title, sort})
        });

        const data = await response.json();

        dispatch({type: CREATE_BOARD_LIST, payload: data});

        SOCKET.emit("board_list", {
            board_id,
            list: data
        });
    };
};
export const RenameBoardListAPI = (id, board_id, title) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/rename_list/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id, title})
        })
        const data = await response.json();

        // dispatch(BoardListsAPI(board_id))

        dispatch({type: RENAME_LIST, payload: data});

        SOCKET.emit("rename_list", {
            board_id,
            list: data
        });
    }
}
export const HandleBoardListAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/handle_board_list/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        })

        if (!response.ok) {
            throw new Error("Could not update board list");
        }

        const data = await response.json();
        return data;
    }
}
export const RemoveBoardListAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/delete/remove_board_list/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        })

        if (!response.ok) {
            throw new Error("Could not delete board list");
        }

        dispatch({type: DELETE_BOARD_LIST, payload: id})
    }
}
export const CreateBoardCardAPI = (board_list_id, name, board_id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/board_card/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({board_list_id, name})
        });

        const data = await response.json();
        const obj = {
            board_id,
            listId: board_list_id,
            card: data
        }
        dispatch({
            type: ADD_CARD_TO_LIST,
            payload: obj
        });
        SOCKET.emit("board_card", obj)
    };
};
export const HandleBoardAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/update/handle_board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        });

        const data = await response.json();

        SOCKET.emit("handle_board", {
            board_id: id,
            board: data
        });

        return data;
    };
};
export const RemoveBoardAPI = (id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/delete/remove_board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        })
        const data = await response.json();
        SOCKET.emit("remove_board", {
            board_id: id
        });
        return data;
    }
}
export const SearchBoardAPI = (id, value) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/search_board/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id, value})
        });
        const data = await response.json();

        dispatch({type: SET_SEARCH_BOARDS, payload: data});
    }
}

export const UploadAttachment = (card_id, file, title, is_cover, board_id) => {
    return async (dispatch) => {
        const maxAttachmentSize = 45 * 1024 * 1024;

        if (!(file instanceof Blob)) {
            throw new Error("Choose an attachment to upload.");
        }

        if (file.size > maxAttachmentSize) {
            throw new Error("The attachment must be 45 MB or smaller.");
        }

        const formData = new FormData();
        formData.append("card_id", card_id);
        formData.append("file", file, file.name || "attachment");
        formData.append("title", title || file.name || "");
        formData.append("is_cover", String(Boolean(is_cover)));

        const response = await fetch(API_URL + "/post/upload_attachment/", {
            method: "POST",
            body: formData
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
            throw new Error(data.error || data.detail || "Could not upload the attachment.");
        }

        const obj = {
            card: card_id,
            id: data.attachment_id,
            file_id: data.id,
            title: data.title,
            url: `/media/${data.path}`,
            name: data.path.split("/").pop(),
            is_cover: data.is_cover,
            created_at: data.created_at || Math.floor(Date.now() / 1000),
        };
        dispatch({
            type: SET_ATTACHMENT,
            payload: obj
        });

        SOCKET.emit("upload_attachment", {
            board_id,
            attachment: obj
        });
    };
};
export const DeleteAttachment = (id, board_id) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/delete/delete_attachment/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        });

        dispatch({type: DELETE_ATTACHMENT, payload: id})

        SOCKET.emit("delete_attachment", {
            board_id,
            attachment_id: id
        });
    }
};

export const MakeCoverAPI = ({ oldId, newId, cardId, board_id }) => {
    return async (dispatch) => {
        await fetch(API_URL + "/post/make_cover/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ oldId, newId })
        });

        const obj = {
            cardId,
            oldId,
            newId
        };

        dispatch({
            type: MAKE_COVER,
            payload: obj
        });

        SOCKET.emit("make_cover", {
            board_id,
            cover: obj
        });
    };
};

export const PostCommentAPI = async (data) => {
    const response = await fetch(API_URL + "/post/add_comment/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.detail || "Comment save failed");
    }

    return result;
};
export const HandleCardMemberAPI = (userId, cardId) => {
    return async (dispatch) => {
        try {
            const response = await fetch(API_URL + "/post/handle_member/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    user_id: userId,
                    card_id: cardId,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                console.error("Handle member error:", data);
                return;
            }

            dispatch({
                type: SET_CARD_MEMBER,
                payload: data,
            });
        } catch (error) {
            console.error("Handle member request error:", error);
        }
    };
};
